module.exports = __webpack_public_path__ + "static/img/LiveRamp-Default.0c27c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/LiveRamp-Default.png
// module id = 1596
// module chunks = 0